import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Publication } from '@widgets/shared/Publication/index.tsx';
import type { PublicationType } from '@widgets/shared/Publication/types.ts';
import { useArticleQuery } from '@src/api/api-hooks/articles/useArticleQuery.ts';
import { useUpdateArticlePublicationMutation } from '@src/api/api-hooks/articles/useUpdateArticlePublicationMutation.ts';

export const ArticlePublicationPage = () => {
  const { articleId } = useParams();
  const { data, isLoading, isFetching, isError, isSuccess } = useArticleQuery({ id: articleId });
  const { mutateAsync: updateArticlePublicationStatus } = useUpdateArticlePublicationMutation();

  const onUpdatePublication = useCallback(
    async (
      publicationData: Partial<PublicationType>
    ): Promise<{ data?: PublicationType; error?: FetchBaseQueryError | SerializedError }> => {
      return updateArticlePublicationStatus({ id: Number(articleId), publicationData });
    },
    [updateArticlePublicationStatus, articleId]
  );

  return (
    <Publication
      entityName={'Статья'}
      onUpdatePublication={onUpdatePublication}
      title={'Публикация статьи'}
      publicationData={data?.publication}
      status={{ isSuccess, isError, isFetching, isLoading }}
    />
  );
};
